module.exports.default = {
    "ORDER": "Auftrag",
    "SCHEDULE.YOU_ARE_ALL_SET": "Sie sind bereit!",
    "SCHEDULE.YOUR_DELIVERY_IS_SCHEDULED_FOR": "Ihre Lieferung ist geplant für",
    "SCHEDULE.CUSTOMER_#_MESSAGE": "Hallo #, bitte planen Sie Ihre Lieferung",
    "SCHEDULE.SCHEDULE_NOW": "Verschieben",
    "SCHEDULE.DELIVERY_STATUS_UPDATES": "Lieferung & Status-Updates",
    "SCHEDULE.EMAIL_UPDATES": "E-Mail-Aktualisierungen",
    "SCHEDULE.SMS_UPDATES": "SMS-Aktualisierung",
    "SCHEDULE.DISABLE_UPDATES": "Ich möchte keine Updates erhalten.",
    "SCHEDULE.STATUS_UPDATE_IN_THE_FOLLOWING": "Ich möchte den aktuellen Status meiner Lieferung in den folgenden Kanälen erhalten:",
    "OOPS": "Oops!",
    "SOMETHING_WENT_WRONG": "Etwas ist schief gelaufen.",
    "REFRESH": "Aktualisieren",
    "PAGE_NOT_FOUND": "Seite nicht gefunden",
    "COULD_NOT_FIND_PAGE": "Wir konnten die von Ihnen gesuchte Seite nicht finden.",
    "TRACKING.MESSAGE_DRIVER_FAILED": "Kann keine leere Nachricht senden",
    "TRACKING.MESSAGE_DRIVER_PLACEHOLDER": "Gern können Sie dem Fahrer-Team eine Nachricht senden",
    "TRACKING.SEND": "Via Nachrichtendienst versenden",
    "TRACKING.ARRIVING_AT": "Ankommend um",
    "TRACKING.ETA": "ETA",
    "TRACKING.MIN": "min",
    "TRACKING.MAP": "Verkehr",
    "TRACKING.SATELLITE": "Satellit",
    "TRACKING.TERRAIN": "Gelände",
    "TRACKING.DRIVER_ARRIVED_MESSAGE": "Hey, ich bin angekommen!",
    "TRACKING.DRIVER_ARRIVED_AT_MESSAGE": "ist angekommen",
    "COMPLETED": "Du hast aktuell keine aktiven Lieferungen",
    "RATING.SKIP": "Nicht jetzt",
    "RATING.WHAT_WENT_WELL": "Was ist gut gelaufen?",
    "RATING.WHAT_WENT_WRONG": "Was ist schief gelaufen?",
    "RATING.THANK_YOU": "Vielen Dank",
    "RATING.FOR_USING_OUR_SERVICE": "Danke, dass Sie unseren Service genutzt haben!",
    "RATING.HOW_WAS_YOUR_DELIVERY": "Wie waren Ihre Erfahrungen bei der Lieferung?",
    "RATING.WHAT_WAS_YOUR_EXPERIENCE": "Bitte helfen Sie uns, uns zu verbessern, in dem Sie Ihre Erfahrung mit uns bewerten",
    "SCHEDULE.RATE_US": "Bewerten Sie uns!",
    "TERM_OF_USE": "Nutzungsbedingungen",
    "PRIVACY_POLICY": "Datenschutzrichtlinie",
    "SHARING_MY_LOCATION": "Finde mich",
    "SHARING_LOADING": "Lädt",
    "REQUIRED_FIELD_MESSAGE": "Alle Felder sind verpflichtend",
    "CONTACT_NAME": "Kontaktname",
    "PHONE_NUMBER": "Telefonnummer",
    "EMAIL_ADDRESS": "E-Mail Adresse",
    "SEND": "senden\n",
    "FORWARD.THIS_ORDER": "Leite die Lieferung weiter",
    "FORWARD.TO_CONTACT": "Leite es an einen Kontakt in",
    "FORWARD.ARE_YOU_SURE_MESSAGE": "Bist du sicher, dass du diese Bestellung weiterleiten möchtest?",
    "FORWARDED.HAS_DELIVERY_FORWARDED_DELIVERY": "hat eine Lieferung an Sie weitergeleitet",
    "FORWARDED.ARE_YOU_SURE_MESSAGE": "Bist du sicher, dass du diese Lieferung ablehnen möchtest?",
    "ACCEPT": "Annehmen",
    "REJECT": "Zurückweisen",
    "PICKUP.SET_PICKUP_TIME": "Ich bin auf dem Weg",
    "PICKUP.IVE_ARRIVED": "Ich bin angekommen",
    "PICKUP.PICKUP_ETA_SET_FAILED": "Hoppla, etwas ist schief gelaufen.\n",
    "PICKUP.ETA_SET_FAILED_DESCRIPTION": "Bitte versuchen Sie es erneut.",
    "PICKUP.MIN": "Min.",
    "PICKUP.SHOW_THIS_NUMBER": "Zeigen Sie diese Nummer dem Angestellten, um Ihre Bestellung zu erhalten",
    "PICKUP.IM_OUTSIDE": "Ich bin hier",
    "PICKUP.LET_THEM_KNOW_YOUR_OUTSIDE?": "Teilen Sie uns mit, wenn Sie hier sind.",
    "PICKUP.I_WILL_ARRIVE_AT": "Ich werde ankommen um",
    "PICKUP.PICKUP_ETA_SUCCESSFULLY_SET": "Abholzeit erfolgreich eingestellt",
    "PICKUP.IN": "In",
    "PICKUP.TO": "Nach",
    "PICKUP.COLLECT": "Bestellung abgeholt",
    "PICKUP.SELECT_METHOD_OF_TRANSPORT": "Transportmittel auswählen",
    "PICKUP.CONFIRM_METHOD_OF_TRANSPORT": "Transportmittel bestätigen",
    "PICKUP.CANCEL": "Abbrechen",
    "PICKUP.CONFIRM_TIME": "Ankunftszeit der Abholung bestätigen",
    "TRACKING.DRIVER_ROUTE_ONE_STOP_MESSAGE": "Der Fahrer ist derzeit einen Stopp von Ihnen entfernt\n",
    "TRACKING.DRIVER_ROUTE_STOPS_MESSAGE_PART2": "Stopps von Ihnen entfernt",
    "TRACKING.DRIVER_ROUTE_STOPS_MESSAGE_PART1": "Der Fahrer ist derzeit",
    "PICKUP.OK": "OK",
    "PICKUP.NEXT": "Weiter",
    "PICKUP.SKIP": "Überspringen",
    "CAR_ARRIVED.TITLE": "Letzter Schritt! Teilen Sie uns mit, wie wir Sie finden können:",
    "CAR_ARRIVED.PARKING_SPOT": "Parkbereich / Stellplatznummer",
    "CAR_ARRIVED.LICENSE_PLATE": "Kennzeichen",
    "CAR_ARRIVED.VEHICLE_MODEL": "Fahrzeugmodell & Marke",
    "CAR_ARRIVED.VEHICLE_COLOR": "Fahrzeugfarbe",
    "CAR_ARRIVED.REMEMBER": "Meine Fahrzeugdetails merken",
    "CAR_ARRIVED.PARKING_SPOT_EXAMPLE": "(Beispiel: C - 49)",
    "CAR_ARRIVED.LICENSE_PLATE_EXAMPLE": "(Beispiel: 195-QUD)",
    "CAR_ARRIVED.VEHICLE_MODEL_EXAMPLE": "(Beispiel: Ford Bronco)",
    "CAR_ARRIVED.VEHICLE_COLOR_EXAMPLE": "(Beispiel: Blau)",
    "REDIRECT_PICKUP.TO": "Nach",
    "REDIRECT_PICKUP.CONFIRM_TITLE": "Den Abholort ändern?",
    "REDIRECT_PICKUP.SUCCESS_TITLE": "Abholort erfolgreich geändert",
    "REDIRECT_PICKUP.FAILED_TITLE": "Abholort konnte nicht geändert werden",
    "REDIRECT_PICKUP.FAILED_DESCRIPTION": "Etwas ist schief gelaufen",
    "REDIRECT_PICKUP.OK": "OK",
    "REDIRECT_PICKUP.KM": "km",
    "REDIRECT_PICKUP.SELECT_PICKUP_LOCATION": "Abholort auswählen",
    "REDIRECT_PICKUP.SET_AS_PICKUP_LOCATION": "Als Abholort festlegen",
    "REDIRECT_PICKUP.PICKUP_OPTIONS": "Abholoptionen",
    "SOON": "bald",
    "TRACKING.WANT_TO_CALL_YOUR_DRIVER": "Möchten Sie Ihren Lieferfahrer anrufen?",
    "GLOBAL.CALL": "Anrufen",
    "GLOBAL.CANCEL": "Abbrechen",
    "﻿PICKUP.SET_PICKUP_TIME": "Ich bin unterwegs",
    "RATING.PROOF_OF_DELIVERY_MESSAGE": "Ihre Bestellung wartet direkt vor Ihrer Tür auf Sie!",
    "SCHEDULED.THANKS_FOR_USING": "Vielen Dank, dass Sie {{merchant_name}} verwendet haben",
    "SCHEDULED.SHIPMENT_IN_TRANSIT": "Ihre Sendung {{external_id}} ist unterwegs",
    "SCHEDULED.YOUR_DELIVERY_IS_SCHEDULED_FOR": "Ihre Bestellung ist geplant für",
    "Submit": "Senden",
    "RATING.SELECT_STARS_BEFORE_SUBMIT": "Um bewerten zu können, wählen Sie zuerst die Sterne",
    "PICKUP.SHOW_ID": "ID anzeigen",
    "TRACKING.ESTIMATED_TIME_ARRIVAL": "Voraussichtliche Ankunftszeit",
    "OPEN_MENU": "Menü öffnen",
    "CLOSE_MENU": "Menü schließen",
    "MAP_AUTO_CENTER": "Karte des Auto Centers",
    "MAP_SETTINGS": "Karteneinstellungen",
    "ZOOM_OUT": "Verkleinern",
    "ZOOM_IN": "Vergrößern",
    "TRACKING.CALL_DRIVER": "Fahrer anrufen",
    "TRACKING.MESSAGE_DRIVER": "Dem Fahrer eine Nachricht senden",
    "PICKUP.SELECT_TIME_TO_CONFIRM": "Ankunftszeit der Abholung bestätigen",
    "PICKUP.SET_OR_ARRIVE_DESCRIPTION": "Wir möchten nicht, dass Sie warten.\nTeilen Sie uns mit, wann Sie unterwegs sind oder ankommen:",
    "SCHEDULE.TIME_ZONE_TEXT": "Zeitzone",
    "TRACKING.THANKS_MESSAGE_SUBTITLE": "Wir arbeiten daran!",
    "TRACKING.THANKS_MESSAGE_TEXT": "Wir sammeln Ihre Artikel und ein Teammitglied wird in Kürze zu Ihrem Auto kommen",
    "TRACKING.THANKS_MESSAGE_TITLE": "Vielen Dank für Ihre Rückmeldung",
    "TRACKING.CLICK_COLLECT_MESSAGE_TEXT": "Bitte gehen Sie zum Abholpunkt im Geschäft, wo Ihre Bestellung zur Abholung bereit ist",
    "CANCEL_ORDER": "Bestellung stornieren",
    "CANCELLATION_VALIDATION_TITLE": "Möchten Sie diese Bestellung wirklich stornieren?",
    "CANCELLATION_VALIDATION_BACK": "Zurück",
    "CANCELLATION_VALIDATION_YES": "Ja, bitte",
    "CANCEL_SUCCESS": "Wir haben Ihre Bestellung storniert",
    "CANCEL_PAST_ALLOWED": "Stornierung der Bestellung abgelaufen",
    "CANCEL_ERROR": "Wir konnten Ihre Bestellung nicht stornieren",
    "RATING.FREE_TEXT_COMMENT": "Erzählen Sie uns mehr",
    "RATING.ORDER_DELIVERED_GREEN": "Wir haben Ihre Bestellung mit einem umweltfreundlichen Fahrzeug geliefert",
    "CX_ORDER_STATUS.CONFIRMED": "Bestellung bestätigt. Sie wird bearbeitet.",
    "CX_ORDER_STATUS.RECEIVED": "Bestellung erhalten. Wir werden uns in Kürze in Verbindung setzen.",
    "CX_ORDER_STATUS.FINDING_DRIVER": "Wir haben einen Fahrer für Ihre Bestellung zugeordnet",
    "CX_ORDER_STATUS.DRIVER_FOUND": "Wir haben den Fahrer für Ihre Bestellung gefunden.",
    "CX_ORDER_STATUS.PICKING_UP": "Wir nehmen Ihre Bestellung gerade auf.",
    "CX_ORDER_STATUS.WAY_TO_PICKUP": "Wir sind auf dem Weg, Ihre Bestellung abzuholen.",
    "CX_ORDER_STATUS.ON_PREVIOUS_DELIVERY": "Wir beenden eine vorherige Lieferung bevor Ihrer Bestellung.",
    "CX_ORDER_STATUS.WAY_TO_DROPOFF": "Ihre Bestellung ist jetzt auf dem Weg zu Ihnen!",
    "CX_ORDER_STATUS.ARRIVED": "Ihre Bestellung ist eingegangen!",
    "TRACKING.DELIVERY_STATUS_TITLE": "Lieferstatus",
    "CONFIGURATION.TAGS.SHOW_DELIVERY_STATUS": "Lieferstatus für Kunden anzeigen",
    "CONFIRM": "Bestätigen",
    "FLOW_OPTIONS.TITLE": "Wie möchten Sie Ihre Bestellung einsammeln?",
    "FLOW_OPTIONS.CURBSIDE_BUTTON_LABEL": "Ausgeliefert zu Ihrem Auto an einem bestimmten Ort",
    "FLOW_OPTIONS.CURBSIDE_BUTTON_TEXT": "Bordsteinseite",
    "FLOW_OPTIONS.CLICK_AND_COLLECT_LABEL": "Abholung im Laden oder an einem festgelegten Ort",
    "FLOW_OPTIONS.CLICK_AND_COLLECT_TEXT": "Klicken & Einsammeln",
    "RATING_STAR_ALT": "Wählen Sie bis zu 5 Sterne, um eine Bewertung abzugeben",
    "RATING_STAR_ALT_ONE": "Wählen Sie, um die Bewertung von",
    "RATING_STAR_ALT_TWO": "Sternen zu verlassen",
    "TRACKING.ARRIVING_IN_ARIA_LABEL": "Die geschätzte Ankunftszeit beträgt",
    "TRACKING.MAP_CONTAINER_ARIA_LABEL": "Karte, um die Reihenfolge zu verfolgen",
    "SCHEDULE.EXTERNAL_ID_INFO": "Auftrag ID: {{externalId}}",
    "SCHEDULE.TASK_NOTE_LABEL": "Kommentar",
    "SCHEDULE.CANCEL_NOTE_INPUT": "Löschen",
    "DELIVERY_WAS_CANCELLED": "Lieferung storniert",
    "QUESTIONNAIRE.SKIP": "Überspringen",
    "QUESTIONNAIRE.SKIP_VALIDATION_HEADER": "Sind Sie sicher, dass Sie überspringen möchten?",
    "QUESTIONNAIRE.SKIP_VALIDATION_MESSAGE": "Einige Fragen wurden noch nicht beantwortet. Sind Sie sicher, dass Sie ohne sie zu beantworten, fortfahren möchten?",
    "QUESTIONNAIRE.BACK": "Zurück",
    "QUESTIONNAIRE.SUBMIT_FAILED": "",
    "QUESTIONNAIRE.SUBMIT_SUCCESS": "",
    "QUESTIONNAIRE.NA_VALUE": "",
    "QUESTIONNAIRE.SUBMIT_SUCCESS_TITLE": "",
    "QUESTIONNAIRE.SUBMIT_SUCCESS_MESSAGE": "",
    "QUESTIONNAIRE.PROGRESS_BAR_TITLE": "",
    "QUESTIONNAIRE.NEXT": "",
    "QUESTIONNAIRE.INVALID_FORMAT": "",
    "RESCHEDULE.NEED_A_DIFFERENT_TIME": "Brauchen Sie einen anderen Termin?",
    "RESCHEDULE.RESCHEDULE_YOUR_DELIVERY": "Ihre Lieferung verschieben",
    "RESCHEDULE.GREETING": "Hallo 👋 Ich bin der Umplanungsassistent von {{merchant_name}}. Ihre Bestellung #{{order_id}} ist für {{delivery_window}} geplant.\n\nMöchten Sie das Lieferfenster ändern? Wählen Sie unten eine Option aus, und wir kümmern uns darum.",
    "RESCHEDULE.FIRST_AVAILABLE": "Nächster freier Termin",
    "RESCHEDULE.SAME_DAY": "Gleicher Tag, andere Uhrzeit",
    "RESCHEDULE.PICK_A_DATE": "Datum auswählen",
    "RESCHEDULE.NEAREST_WINDOWS": "Hier sind die nächsten verfügbaren Lieferfenster. Wählen Sie das Datum aus, das Ihnen passt",
    "RESCHEDULE.WINDOWS_FOR_DATE": "Hier sind alle verfügbaren Lieferfenster für {{date}}. Wählen Sie das aus, das Ihnen passt",
    "RESCHEDULE.WHICH_DATE": "Welches Datum passt Ihnen am besten?",
    "RESCHEDULE.NO_WINDOWS": "Leider sind für diesen Tag keine Lieferfenster verfügbar. Versuchen Sie es mit einem anderen Datum",
    "RESCHEDULE.NO_WINDOWS_AVAILABLE": "Leider sind derzeit keine Lieferfenster für eine Umplanung verfügbar.",
    "RESCHEDULE.SOMETHING_WENT_WRONG": "Beim Laden der verfügbaren Lieferfenster ist ein Fehler aufgetreten. Bitte versuchen Sie es erneut.",
    "RESCHEDULE.TRY_AGAIN": "Erneut versuchen",
    "RESCHEDULE.BACK_TO_START": "Zurück zum Anfang",
    "RESCHEDULE.BACK_TO_DELIVERY": "Zurück zu meiner Lieferung",
    "RESCHEDULE.CONFIRMED": "Alles erledigt! Die Lieferung ist jetzt für {{delivery_window}} geplant. Einen schönen Tag noch!",
    "RESCHEDULE.TYPE_A_MESSAGE": "Nachricht eingeben",
    "RESCHEDULE.TODAY": "Heute"
};
	